import controller from './asset-upload-drop-zone.controller'

export default {
  template: require('./asset-upload-drop-zone.component.html').default,
  controller
}
